import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { centralizedHost } from "~/Utils";

interface PrivacyPolicyTabOneResponse {
  id?: number;
  title: string;
  description: string;
  section: string;
  parent_id_1: string;
  published: boolean;
  created_by?: string;
  last_modified_by?: string;
}

// Edit API call
const fetchPrivacyPolicyTabOne = async (id?: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await axios.get(`${centralizedHost}/api/privacy-policy-list/tab-1/${id}`);
  const data = response.data[0];
  return data;
};

const usePrivacyPolicyTabOnePara = (
  id?: string,
  options?: UseQueryOptions<PrivacyPolicyTabOneResponse, DefaultError, PrivacyPolicyTabOneResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<PrivacyPolicyTabOneResponse, DefaultError> => {
  return useQuery<PrivacyPolicyTabOneResponse, DefaultError, PrivacyPolicyTabOneResponse, QueryKey>(
    {
      queryKey: ["privacyPolicyTabOnePara", id],
      enabled: false,
      queryFn: () => {
        return fetchPrivacyPolicyTabOne(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { usePrivacyPolicyTabOnePara };
